var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"text-capitalize button-red-round",attrs:{"dark":"","small":""},on:{"click":_vm.launchPasswordStep}},[_vm._v(" Cambiar password ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }